/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Authorization,
  ChunksAbortRequest,
  ChunksAbortResponse,
  ChunksCompleteRequest,
  ChunksInitRequest,
  ChunksInitResponse,
  CreateVisitFormRequest,
  GenerateFormLinkResponse,
  HTTPValidationError,
  JobStatusResponse,
  ListingVisitFormsResponse,
  MediaFile,
  ReviewerUpdateStatusRequest,
  StartTranscriptionRequest,
  StartTranscriptionResponse,
  SubmitVisitFormRequest,
  SubmitVisitFormResponse,
  UpdateVisitFormRequest,
  VisitFormDraft,
  VisitFormListResponse,
} from '../models/index';
import {
    AuthorizationFromJSON,
    AuthorizationToJSON,
    ChunksAbortRequestFromJSON,
    ChunksAbortRequestToJSON,
    ChunksAbortResponseFromJSON,
    ChunksAbortResponseToJSON,
    ChunksCompleteRequestFromJSON,
    ChunksCompleteRequestToJSON,
    ChunksInitRequestFromJSON,
    ChunksInitRequestToJSON,
    ChunksInitResponseFromJSON,
    ChunksInitResponseToJSON,
    CreateVisitFormRequestFromJSON,
    CreateVisitFormRequestToJSON,
    GenerateFormLinkResponseFromJSON,
    GenerateFormLinkResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    JobStatusResponseFromJSON,
    JobStatusResponseToJSON,
    ListingVisitFormsResponseFromJSON,
    ListingVisitFormsResponseToJSON,
    MediaFileFromJSON,
    MediaFileToJSON,
    ReviewerUpdateStatusRequestFromJSON,
    ReviewerUpdateStatusRequestToJSON,
    StartTranscriptionRequestFromJSON,
    StartTranscriptionRequestToJSON,
    StartTranscriptionResponseFromJSON,
    StartTranscriptionResponseToJSON,
    SubmitVisitFormRequestFromJSON,
    SubmitVisitFormRequestToJSON,
    SubmitVisitFormResponseFromJSON,
    SubmitVisitFormResponseToJSON,
    UpdateVisitFormRequestFromJSON,
    UpdateVisitFormRequestToJSON,
    VisitFormDraftFromJSON,
    VisitFormDraftToJSON,
    VisitFormListResponseFromJSON,
    VisitFormListResponseToJSON,
} from '../models/index';

export interface AbortChunksUploadApiV1VisitFormsChunkUploadAbortPostRequest {
    chunksAbortRequest: ChunksAbortRequest;
}

export interface CompleteChunksUploadApiV1VisitFormsChunkUploadCompletePostRequest {
    chunksCompleteRequest: ChunksCompleteRequest;
}

export interface CreateDraftApiV1VisitFormsPostRequest {
    createVisitFormRequest: CreateVisitFormRequest;
    authorization?: Authorization;
}

export interface DeleteMediaApiV1VisitFormsDraftIdMediaMediaIdDeleteRequest {
    draftId: string;
    mediaId: string;
    authorization?: Authorization;
}

export interface DownloadPrewalkPhotosZipApiV1VisitFormsPrewalkPhotosZipVisitFormIdPostRequest {
    visitFormId: string;
    stamped?: boolean;
}

export interface GetDraftApiV1VisitFormsDraftIdGetRequest {
    draftId: string;
}

export interface GetFormLinkByVisitFormIdApiV1VisitFormsVisitFormVisitFormIdGetRequest {
    visitFormId: string;
}

export interface GetListingVisitFormsApiV1VisitFormsListingListingIdGetRequest {
    listingId: string;
}

export interface GetMediaDownloadUrlApiV1VisitFormsDownloadMediaMediaIdGetRequest {
    mediaId: string;
}

export interface GetTranscriptionStatusApiV1VisitFormsTranscribeStatusMediaIdJobNameGetRequest {
    mediaId: string;
    jobName: string;
}

export interface GetWalkthroughVideoSignedUrlsApiV1VisitFormsVideoSignedUrlsVisitFormIdGetRequest {
    visitFormId: string;
}

export interface InitChunksUploadApiV1VisitFormsChunkUploadInitPostRequest {
    chunksInitRequest: ChunksInitRequest;
}

export interface ListDraftsApiV1VisitFormsGetRequest {
    status?: string;
    limit?: number;
    offset?: number;
    authorization?: Authorization;
}

export interface ListPrewalkPhotosApiV1VisitFormsPrewalkPhotosVisitFormIdGetRequest {
    visitFormId: string;
}

export interface ReviewerUpdateStatusApiV1VisitFormsDraftIdReviewerStatusPatchRequest {
    draftId: string;
    reviewerUpdateStatusRequest: ReviewerUpdateStatusRequest;
}

export interface StartTranscriptionApiV1VisitFormsTranscribeStartPostRequest {
    startTranscriptionRequest: StartTranscriptionRequest;
}

export interface SubmitFormApiV1VisitFormsDraftIdSubmitPostRequest {
    draftId: string;
    submitVisitFormRequest: SubmitVisitFormRequest;
}

export interface UpdateDraftApiV1VisitFormsDraftIdPatchRequest {
    draftId: string;
    updateVisitFormRequest: UpdateVisitFormRequest;
    authorization?: Authorization;
}

export interface UploadMediaApiV1VisitFormsDraftIdMediaPostRequest {
    draftId: string;
    files: Array<Blob>;
    sectionNumber: number;
    mediaType: string;
    authorization?: Authorization;
}

/**
 * 
 */
export class VisitFormsApi extends runtime.BaseAPI {

    /**
     * Abort the chunks upload process for a visit form.
     * Abort chunks upload
     */
    async abortChunksUploadApiV1VisitFormsChunkUploadAbortPostRaw(requestParameters: AbortChunksUploadApiV1VisitFormsChunkUploadAbortPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChunksAbortResponse>> {
        if (requestParameters.chunksAbortRequest === null || requestParameters.chunksAbortRequest === undefined) {
            throw new runtime.RequiredError('chunksAbortRequest','Required parameter requestParameters.chunksAbortRequest was null or undefined when calling abortChunksUploadApiV1VisitFormsChunkUploadAbortPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/visit-forms/chunk-upload/abort`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChunksAbortRequestToJSON(requestParameters.chunksAbortRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChunksAbortResponseFromJSON(jsonValue));
    }

    /**
     * Abort the chunks upload process for a visit form.
     * Abort chunks upload
     */
    async abortChunksUploadApiV1VisitFormsChunkUploadAbortPost(requestParameters: AbortChunksUploadApiV1VisitFormsChunkUploadAbortPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChunksAbortResponse> {
        const response = await this.abortChunksUploadApiV1VisitFormsChunkUploadAbortPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Complete the chunks upload process for a visit form.
     * Complete chunks upload
     */
    async completeChunksUploadApiV1VisitFormsChunkUploadCompletePostRaw(requestParameters: CompleteChunksUploadApiV1VisitFormsChunkUploadCompletePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MediaFile>> {
        if (requestParameters.chunksCompleteRequest === null || requestParameters.chunksCompleteRequest === undefined) {
            throw new runtime.RequiredError('chunksCompleteRequest','Required parameter requestParameters.chunksCompleteRequest was null or undefined when calling completeChunksUploadApiV1VisitFormsChunkUploadCompletePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/visit-forms/chunk-upload/complete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChunksCompleteRequestToJSON(requestParameters.chunksCompleteRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaFileFromJSON(jsonValue));
    }

    /**
     * Complete the chunks upload process for a visit form.
     * Complete chunks upload
     */
    async completeChunksUploadApiV1VisitFormsChunkUploadCompletePost(requestParameters: CompleteChunksUploadApiV1VisitFormsChunkUploadCompletePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MediaFile> {
        const response = await this.completeChunksUploadApiV1VisitFormsChunkUploadCompletePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new visit form on page load. Sets status to \'in_progress\' automatically.
     * Create new visit form
     */
    async createDraftApiV1VisitFormsPostRaw(requestParameters: CreateDraftApiV1VisitFormsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VisitFormDraft>> {
        if (requestParameters.createVisitFormRequest === null || requestParameters.createVisitFormRequest === undefined) {
            throw new runtime.RequiredError('createVisitFormRequest','Required parameter requestParameters.createVisitFormRequest was null or undefined when calling createDraftApiV1VisitFormsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['authorization'] = String(requestParameters.authorization);
        }

        const response = await this.request({
            path: `/api/v1/visit-forms/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateVisitFormRequestToJSON(requestParameters.createVisitFormRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VisitFormDraftFromJSON(jsonValue));
    }

    /**
     * Create a new visit form on page load. Sets status to \'in_progress\' automatically.
     * Create new visit form
     */
    async createDraftApiV1VisitFormsPost(requestParameters: CreateDraftApiV1VisitFormsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VisitFormDraft> {
        const response = await this.createDraftApiV1VisitFormsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft delete a media file from a visit form.
     * Delete media file
     */
    async deleteMediaApiV1VisitFormsDraftIdMediaMediaIdDeleteRaw(requestParameters: DeleteMediaApiV1VisitFormsDraftIdMediaMediaIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.draftId === null || requestParameters.draftId === undefined) {
            throw new runtime.RequiredError('draftId','Required parameter requestParameters.draftId was null or undefined when calling deleteMediaApiV1VisitFormsDraftIdMediaMediaIdDelete.');
        }

        if (requestParameters.mediaId === null || requestParameters.mediaId === undefined) {
            throw new runtime.RequiredError('mediaId','Required parameter requestParameters.mediaId was null or undefined when calling deleteMediaApiV1VisitFormsDraftIdMediaMediaIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['authorization'] = String(requestParameters.authorization);
        }

        const response = await this.request({
            path: `/api/v1/visit-forms/{draft_id}/media/{media_id}`.replace(`{${"draft_id"}}`, encodeURIComponent(String(requestParameters.draftId))).replace(`{${"media_id"}}`, encodeURIComponent(String(requestParameters.mediaId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft delete a media file from a visit form.
     * Delete media file
     */
    async deleteMediaApiV1VisitFormsDraftIdMediaMediaIdDelete(requestParameters: DeleteMediaApiV1VisitFormsDraftIdMediaMediaIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMediaApiV1VisitFormsDraftIdMediaMediaIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Stream a ZIP containing all prewalk photos for a visit form using signed URLs.
     * Download prewalk photos zip for a visit form
     */
    async downloadPrewalkPhotosZipApiV1VisitFormsPrewalkPhotosZipVisitFormIdPostRaw(requestParameters: DownloadPrewalkPhotosZipApiV1VisitFormsPrewalkPhotosZipVisitFormIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.visitFormId === null || requestParameters.visitFormId === undefined) {
            throw new runtime.RequiredError('visitFormId','Required parameter requestParameters.visitFormId was null or undefined when calling downloadPrewalkPhotosZipApiV1VisitFormsPrewalkPhotosZipVisitFormIdPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.stamped !== undefined) {
            queryParameters['stamped'] = requestParameters.stamped;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/visit-forms/prewalk_photos/zip/{visit_form_id}`.replace(`{${"visit_form_id"}}`, encodeURIComponent(String(requestParameters.visitFormId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Stream a ZIP containing all prewalk photos for a visit form using signed URLs.
     * Download prewalk photos zip for a visit form
     */
    async downloadPrewalkPhotosZipApiV1VisitFormsPrewalkPhotosZipVisitFormIdPost(requestParameters: DownloadPrewalkPhotosZipApiV1VisitFormsPrewalkPhotosZipVisitFormIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.downloadPrewalkPhotosZipApiV1VisitFormsPrewalkPhotosZipVisitFormIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a visit form by ID with all associated media files.
     * Get visit form
     */
    async getDraftApiV1VisitFormsDraftIdGetRaw(requestParameters: GetDraftApiV1VisitFormsDraftIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VisitFormDraft>> {
        if (requestParameters.draftId === null || requestParameters.draftId === undefined) {
            throw new runtime.RequiredError('draftId','Required parameter requestParameters.draftId was null or undefined when calling getDraftApiV1VisitFormsDraftIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/visit-forms/{draft_id}`.replace(`{${"draft_id"}}`, encodeURIComponent(String(requestParameters.draftId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VisitFormDraftFromJSON(jsonValue));
    }

    /**
     * Retrieve a visit form by ID with all associated media files.
     * Get visit form
     */
    async getDraftApiV1VisitFormsDraftIdGet(requestParameters: GetDraftApiV1VisitFormsDraftIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VisitFormDraft> {
        const response = await this.getDraftApiV1VisitFormsDraftIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the form link with JWT token for a given visit form ID.  This is used to generate links for agents to access their visit forms.
     * Get Form Link By Visit Form Id
     */
    async getFormLinkByVisitFormIdApiV1VisitFormsVisitFormVisitFormIdGetRaw(requestParameters: GetFormLinkByVisitFormIdApiV1VisitFormsVisitFormVisitFormIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateFormLinkResponse>> {
        if (requestParameters.visitFormId === null || requestParameters.visitFormId === undefined) {
            throw new runtime.RequiredError('visitFormId','Required parameter requestParameters.visitFormId was null or undefined when calling getFormLinkByVisitFormIdApiV1VisitFormsVisitFormVisitFormIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/visit-forms/visit-form/{visit_form_id}`.replace(`{${"visit_form_id"}}`, encodeURIComponent(String(requestParameters.visitFormId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateFormLinkResponseFromJSON(jsonValue));
    }

    /**
     * Get the form link with JWT token for a given visit form ID.  This is used to generate links for agents to access their visit forms.
     * Get Form Link By Visit Form Id
     */
    async getFormLinkByVisitFormIdApiV1VisitFormsVisitFormVisitFormIdGet(requestParameters: GetFormLinkByVisitFormIdApiV1VisitFormsVisitFormVisitFormIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateFormLinkResponse> {
        const response = await this.getFormLinkByVisitFormIdApiV1VisitFormsVisitFormVisitFormIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return all visit forms tied to a listing for internal visibility in Ops tools.
     * Get visit forms for a listing
     */
    async getListingVisitFormsApiV1VisitFormsListingListingIdGetRaw(requestParameters: GetListingVisitFormsApiV1VisitFormsListingListingIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListingVisitFormsResponse>> {
        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling getListingVisitFormsApiV1VisitFormsListingListingIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/visit-forms/listing/{listing_id}`.replace(`{${"listing_id"}}`, encodeURIComponent(String(requestParameters.listingId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListingVisitFormsResponseFromJSON(jsonValue));
    }

    /**
     * Return all visit forms tied to a listing for internal visibility in Ops tools.
     * Get visit forms for a listing
     */
    async getListingVisitFormsApiV1VisitFormsListingListingIdGet(requestParameters: GetListingVisitFormsApiV1VisitFormsListingListingIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListingVisitFormsResponse> {
        const response = await this.getListingVisitFormsApiV1VisitFormsListingListingIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate a signed URL with Content-Disposition header to force download of media file.
     * Get download URL for media file
     */
    async getMediaDownloadUrlApiV1VisitFormsDownloadMediaMediaIdGetRaw(requestParameters: GetMediaDownloadUrlApiV1VisitFormsDownloadMediaMediaIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MediaFile>> {
        if (requestParameters.mediaId === null || requestParameters.mediaId === undefined) {
            throw new runtime.RequiredError('mediaId','Required parameter requestParameters.mediaId was null or undefined when calling getMediaDownloadUrlApiV1VisitFormsDownloadMediaMediaIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/visit-forms/download_media/{media_id}`.replace(`{${"media_id"}}`, encodeURIComponent(String(requestParameters.mediaId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaFileFromJSON(jsonValue));
    }

    /**
     * Generate a signed URL with Content-Disposition header to force download of media file.
     * Get download URL for media file
     */
    async getMediaDownloadUrlApiV1VisitFormsDownloadMediaMediaIdGet(requestParameters: GetMediaDownloadUrlApiV1VisitFormsDownloadMediaMediaIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MediaFile> {
        const response = await this.getMediaDownloadUrlApiV1VisitFormsDownloadMediaMediaIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the status and transcript of a transcription job.
     * Get transcription job status
     */
    async getTranscriptionStatusApiV1VisitFormsTranscribeStatusMediaIdJobNameGetRaw(requestParameters: GetTranscriptionStatusApiV1VisitFormsTranscribeStatusMediaIdJobNameGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobStatusResponse>> {
        if (requestParameters.mediaId === null || requestParameters.mediaId === undefined) {
            throw new runtime.RequiredError('mediaId','Required parameter requestParameters.mediaId was null or undefined when calling getTranscriptionStatusApiV1VisitFormsTranscribeStatusMediaIdJobNameGet.');
        }

        if (requestParameters.jobName === null || requestParameters.jobName === undefined) {
            throw new runtime.RequiredError('jobName','Required parameter requestParameters.jobName was null or undefined when calling getTranscriptionStatusApiV1VisitFormsTranscribeStatusMediaIdJobNameGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/visit-forms/transcribe/status/{media_id}/{job_name}`.replace(`{${"media_id"}}`, encodeURIComponent(String(requestParameters.mediaId))).replace(`{${"job_name"}}`, encodeURIComponent(String(requestParameters.jobName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobStatusResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve the status and transcript of a transcription job.
     * Get transcription job status
     */
    async getTranscriptionStatusApiV1VisitFormsTranscribeStatusMediaIdJobNameGet(requestParameters: GetTranscriptionStatusApiV1VisitFormsTranscribeStatusMediaIdJobNameGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JobStatusResponse> {
        const response = await this.getTranscriptionStatusApiV1VisitFormsTranscribeStatusMediaIdJobNameGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate signed URLs for the walkthrough videos associated with a visit form.
     * Get signed URLs for video files
     */
    async getWalkthroughVideoSignedUrlsApiV1VisitFormsVideoSignedUrlsVisitFormIdGetRaw(requestParameters: GetWalkthroughVideoSignedUrlsApiV1VisitFormsVideoSignedUrlsVisitFormIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MediaFile>>> {
        if (requestParameters.visitFormId === null || requestParameters.visitFormId === undefined) {
            throw new runtime.RequiredError('visitFormId','Required parameter requestParameters.visitFormId was null or undefined when calling getWalkthroughVideoSignedUrlsApiV1VisitFormsVideoSignedUrlsVisitFormIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/visit-forms/video_signed_urls/{visit_form_id}`.replace(`{${"visit_form_id"}}`, encodeURIComponent(String(requestParameters.visitFormId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MediaFileFromJSON));
    }

    /**
     * Generate signed URLs for the walkthrough videos associated with a visit form.
     * Get signed URLs for video files
     */
    async getWalkthroughVideoSignedUrlsApiV1VisitFormsVideoSignedUrlsVisitFormIdGet(requestParameters: GetWalkthroughVideoSignedUrlsApiV1VisitFormsVideoSignedUrlsVisitFormIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MediaFile>> {
        const response = await this.getWalkthroughVideoSignedUrlsApiV1VisitFormsVideoSignedUrlsVisitFormIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Initialize the chunks upload process for a visit form.
     * Initialize chunks upload
     */
    async initChunksUploadApiV1VisitFormsChunkUploadInitPostRaw(requestParameters: InitChunksUploadApiV1VisitFormsChunkUploadInitPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChunksInitResponse>> {
        if (requestParameters.chunksInitRequest === null || requestParameters.chunksInitRequest === undefined) {
            throw new runtime.RequiredError('chunksInitRequest','Required parameter requestParameters.chunksInitRequest was null or undefined when calling initChunksUploadApiV1VisitFormsChunkUploadInitPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/visit-forms/chunk-upload/init`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChunksInitRequestToJSON(requestParameters.chunksInitRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChunksInitResponseFromJSON(jsonValue));
    }

    /**
     * Initialize the chunks upload process for a visit form.
     * Initialize chunks upload
     */
    async initChunksUploadApiV1VisitFormsChunkUploadInitPost(requestParameters: InitChunksUploadApiV1VisitFormsChunkUploadInitPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChunksInitResponse> {
        const response = await this.initChunksUploadApiV1VisitFormsChunkUploadInitPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all visit forms for the authenticated agent with optional filtering and pagination.
     * List agent\'s visit forms
     */
    async listDraftsApiV1VisitFormsGetRaw(requestParameters: ListDraftsApiV1VisitFormsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VisitFormListResponse>> {
        const queryParameters: any = {};

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['authorization'] = String(requestParameters.authorization);
        }

        const response = await this.request({
            path: `/api/v1/visit-forms/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VisitFormListResponseFromJSON(jsonValue));
    }

    /**
     * Get all visit forms for the authenticated agent with optional filtering and pagination.
     * List agent\'s visit forms
     */
    async listDraftsApiV1VisitFormsGet(requestParameters: ListDraftsApiV1VisitFormsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VisitFormListResponse> {
        const response = await this.listDraftsApiV1VisitFormsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all prewalk photos for a visit form with signed URLs.
     * List prewalk photos for a visit form
     */
    async listPrewalkPhotosApiV1VisitFormsPrewalkPhotosVisitFormIdGetRaw(requestParameters: ListPrewalkPhotosApiV1VisitFormsPrewalkPhotosVisitFormIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MediaFile>>> {
        if (requestParameters.visitFormId === null || requestParameters.visitFormId === undefined) {
            throw new runtime.RequiredError('visitFormId','Required parameter requestParameters.visitFormId was null or undefined when calling listPrewalkPhotosApiV1VisitFormsPrewalkPhotosVisitFormIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/visit-forms/prewalk_photos/{visit_form_id}`.replace(`{${"visit_form_id"}}`, encodeURIComponent(String(requestParameters.visitFormId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MediaFileFromJSON));
    }

    /**
     * Get all prewalk photos for a visit form with signed URLs.
     * List prewalk photos for a visit form
     */
    async listPrewalkPhotosApiV1VisitFormsPrewalkPhotosVisitFormIdGet(requestParameters: ListPrewalkPhotosApiV1VisitFormsPrewalkPhotosVisitFormIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MediaFile>> {
        const response = await this.listPrewalkPhotosApiV1VisitFormsPrewalkPhotosVisitFormIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Allows an internal reviewer to change a visit form status (complete, expire, or reopen) with a required reason.
     * Update visit form status as reviewer
     */
    async reviewerUpdateStatusApiV1VisitFormsDraftIdReviewerStatusPatchRaw(requestParameters: ReviewerUpdateStatusApiV1VisitFormsDraftIdReviewerStatusPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VisitFormDraft>> {
        if (requestParameters.draftId === null || requestParameters.draftId === undefined) {
            throw new runtime.RequiredError('draftId','Required parameter requestParameters.draftId was null or undefined when calling reviewerUpdateStatusApiV1VisitFormsDraftIdReviewerStatusPatch.');
        }

        if (requestParameters.reviewerUpdateStatusRequest === null || requestParameters.reviewerUpdateStatusRequest === undefined) {
            throw new runtime.RequiredError('reviewerUpdateStatusRequest','Required parameter requestParameters.reviewerUpdateStatusRequest was null or undefined when calling reviewerUpdateStatusApiV1VisitFormsDraftIdReviewerStatusPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/visit-forms/{draft_id}/reviewer-status`.replace(`{${"draft_id"}}`, encodeURIComponent(String(requestParameters.draftId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ReviewerUpdateStatusRequestToJSON(requestParameters.reviewerUpdateStatusRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VisitFormDraftFromJSON(jsonValue));
    }

    /**
     * Allows an internal reviewer to change a visit form status (complete, expire, or reopen) with a required reason.
     * Update visit form status as reviewer
     */
    async reviewerUpdateStatusApiV1VisitFormsDraftIdReviewerStatusPatch(requestParameters: ReviewerUpdateStatusApiV1VisitFormsDraftIdReviewerStatusPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VisitFormDraft> {
        const response = await this.reviewerUpdateStatusApiV1VisitFormsDraftIdReviewerStatusPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Initiate transcription of a video media file.
     * Start video transcription for a media file
     */
    async startTranscriptionApiV1VisitFormsTranscribeStartPostRaw(requestParameters: StartTranscriptionApiV1VisitFormsTranscribeStartPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartTranscriptionResponse>> {
        if (requestParameters.startTranscriptionRequest === null || requestParameters.startTranscriptionRequest === undefined) {
            throw new runtime.RequiredError('startTranscriptionRequest','Required parameter requestParameters.startTranscriptionRequest was null or undefined when calling startTranscriptionApiV1VisitFormsTranscribeStartPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/visit-forms/transcribe/start`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartTranscriptionRequestToJSON(requestParameters.startTranscriptionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StartTranscriptionResponseFromJSON(jsonValue));
    }

    /**
     * Initiate transcription of a video media file.
     * Start video transcription for a media file
     */
    async startTranscriptionApiV1VisitFormsTranscribeStartPost(requestParameters: StartTranscriptionApiV1VisitFormsTranscribeStartPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartTranscriptionResponse> {
        const response = await this.startTranscriptionApiV1VisitFormsTranscribeStartPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Finalize and submit the visit form. Sets status to \'complete\' and triggers processing.
     * Submit visit form
     */
    async submitFormApiV1VisitFormsDraftIdSubmitPostRaw(requestParameters: SubmitFormApiV1VisitFormsDraftIdSubmitPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmitVisitFormResponse>> {
        if (requestParameters.draftId === null || requestParameters.draftId === undefined) {
            throw new runtime.RequiredError('draftId','Required parameter requestParameters.draftId was null or undefined when calling submitFormApiV1VisitFormsDraftIdSubmitPost.');
        }

        if (requestParameters.submitVisitFormRequest === null || requestParameters.submitVisitFormRequest === undefined) {
            throw new runtime.RequiredError('submitVisitFormRequest','Required parameter requestParameters.submitVisitFormRequest was null or undefined when calling submitFormApiV1VisitFormsDraftIdSubmitPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/visit-forms/{draft_id}/submit`.replace(`{${"draft_id"}}`, encodeURIComponent(String(requestParameters.draftId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitVisitFormRequestToJSON(requestParameters.submitVisitFormRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmitVisitFormResponseFromJSON(jsonValue));
    }

    /**
     * Finalize and submit the visit form. Sets status to \'complete\' and triggers processing.
     * Submit visit form
     */
    async submitFormApiV1VisitFormsDraftIdSubmitPost(requestParameters: SubmitFormApiV1VisitFormsDraftIdSubmitPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmitVisitFormResponse> {
        const response = await this.submitFormApiV1VisitFormsDraftIdSubmitPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update visit form with new form data (progressive save). Form data is merged with existing data.
     * Update visit form
     */
    async updateDraftApiV1VisitFormsDraftIdPatchRaw(requestParameters: UpdateDraftApiV1VisitFormsDraftIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VisitFormDraft>> {
        if (requestParameters.draftId === null || requestParameters.draftId === undefined) {
            throw new runtime.RequiredError('draftId','Required parameter requestParameters.draftId was null or undefined when calling updateDraftApiV1VisitFormsDraftIdPatch.');
        }

        if (requestParameters.updateVisitFormRequest === null || requestParameters.updateVisitFormRequest === undefined) {
            throw new runtime.RequiredError('updateVisitFormRequest','Required parameter requestParameters.updateVisitFormRequest was null or undefined when calling updateDraftApiV1VisitFormsDraftIdPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['authorization'] = String(requestParameters.authorization);
        }

        const response = await this.request({
            path: `/api/v1/visit-forms/{draft_id}`.replace(`{${"draft_id"}}`, encodeURIComponent(String(requestParameters.draftId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateVisitFormRequestToJSON(requestParameters.updateVisitFormRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VisitFormDraftFromJSON(jsonValue));
    }

    /**
     * Update visit form with new form data (progressive save). Form data is merged with existing data.
     * Update visit form
     */
    async updateDraftApiV1VisitFormsDraftIdPatch(requestParameters: UpdateDraftApiV1VisitFormsDraftIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VisitFormDraft> {
        const response = await this.updateDraftApiV1VisitFormsDraftIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload one or more photos or videos to a visit form. Files are stored in S3.
     * Upload media files
     */
    async uploadMediaApiV1VisitFormsDraftIdMediaPostRaw(requestParameters: UploadMediaApiV1VisitFormsDraftIdMediaPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MediaFile>>> {
        if (requestParameters.draftId === null || requestParameters.draftId === undefined) {
            throw new runtime.RequiredError('draftId','Required parameter requestParameters.draftId was null or undefined when calling uploadMediaApiV1VisitFormsDraftIdMediaPost.');
        }

        if (requestParameters.files === null || requestParameters.files === undefined) {
            throw new runtime.RequiredError('files','Required parameter requestParameters.files was null or undefined when calling uploadMediaApiV1VisitFormsDraftIdMediaPost.');
        }

        if (requestParameters.sectionNumber === null || requestParameters.sectionNumber === undefined) {
            throw new runtime.RequiredError('sectionNumber','Required parameter requestParameters.sectionNumber was null or undefined when calling uploadMediaApiV1VisitFormsDraftIdMediaPost.');
        }

        if (requestParameters.mediaType === null || requestParameters.mediaType === undefined) {
            throw new runtime.RequiredError('mediaType','Required parameter requestParameters.mediaType was null or undefined when calling uploadMediaApiV1VisitFormsDraftIdMediaPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['authorization'] = String(requestParameters.authorization);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.files) {
            requestParameters.files.forEach((element) => {
                formParams.append('files', element as any);
            })
        }

        if (requestParameters.sectionNumber !== undefined) {
            formParams.append('section_number', requestParameters.sectionNumber as any);
        }

        if (requestParameters.mediaType !== undefined) {
            formParams.append('media_type', requestParameters.mediaType as any);
        }

        const response = await this.request({
            path: `/api/v1/visit-forms/{draft_id}/media`.replace(`{${"draft_id"}}`, encodeURIComponent(String(requestParameters.draftId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MediaFileFromJSON));
    }

    /**
     * Upload one or more photos or videos to a visit form. Files are stored in S3.
     * Upload media files
     */
    async uploadMediaApiV1VisitFormsDraftIdMediaPost(requestParameters: UploadMediaApiV1VisitFormsDraftIdMediaPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MediaFile>> {
        const response = await this.uploadMediaApiV1VisitFormsDraftIdMediaPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
